import React, { Component } from 'react';
import * as utils from './Utils';
export default class SaveCardForm extends Component {
    componentDidMount () {
        document.getElementById('citiSaveCardForm').submit();
    }
    render () {
        const urlParams = utils.getURLParameters();
        let appParam = '';
        let siteId = '';
        let scParam = '';
        let peSequenceNum = '';
        let insideCheckout = (urlParams.insidecheckout && urlParams.insidecheckout==='true') ? 'I' : 'O';
        if (this.props.formData.postUrl.indexOf('app=') == -1) {
            appParam = urlParams.app ? '?app=' + urlParams.app : '?app=UNSOL';
            siteId = urlParams.siteid ? '&siteId=' + urlParams.siteid : '&siteId=PLCN_HOMEDEPOT';
            scParam = urlParams.sc ? '&sc=' + urlParams.sc : '&sc=30005';
            peSequenceNum = urlParams.uid ? '&uid=' + urlParams.uid : '';
        }
        const cmpId = urlParams.cmp ? '&cmp=' + urlParams.cmp : '';
         
        const postUrl = this.props.formData.postUrl + appParam + siteId + scParam + peSequenceNum + cmpId;
        return (
            <React.Fragment>
                <form method="POST" id="citiSaveCardForm" action={postUrl} name="citiSaveCardForm">
                    <input type="hidden" name="CUST_SESSION_ID" value={this.props.formData.customerId}></input>
                    <input type="hidden" name="MERCHANT_PROCESS_TYPE" value={insideCheckout}></input>
                    <input type="hidden" name="MERCHANT_USER_TYPE" value={this.props.formData.merchantUserType}></input>
                    <input type="hidden" name="Env" value={this.props.formData.env}></input>
                    <input type="hidden" name="returnpage" value={this.props.formData.returnPage}></input>
                </form>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/SaveThdCreditCard/SaveCardForm.js